import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

/**
 * Sets the value of isCrossLocationOpenShift in the shift editor view state.
 * @param isCrossLocationOpenShift - The new value for isCrossLocationOpenShift.
 */
export default mutatorAction("setIsCrossLocationOpenShift", function setIsCrossLocationOpenShift(isCrossLocationOpenShift: boolean) {
    shiftEditorViewState().openShift.isCrossLocationOpenShift = isCrossLocationOpenShift;
});